<template>
  <div>
    <div v-if="data != null">
      <div class="header" :style="data.color != null && data.color.background_color ? 'background-color:'+data.color.background_color : ''">
        <div class="container">
          <div class="row">
            <div class="col-6" v-if="data != null">
              <img :src="montarUrl('logo', data.orcamento.lojista_orcamento[0].project_logo)" class="logo">
            </div>

            <div class="col-6 pagamentoSeguro">
              <svg width="89" height="19" viewBox="0 0 89 19" :fill="data.color != null && data.color.menu_header_color ? data.color.menu_header_color : '#898792'" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 14.1875V8.5C9.75 8.05127 9.38623 7.6875 8.9375 7.6875L2.4375 7.6875C1.98877 7.6875 1.625 8.05127 1.625 8.5L1.625 14.1875C1.625 14.6362 1.98877 15 2.4375 15H8.9375C9.38623 15 9.75 14.6362 9.75 14.1875ZM11.375 8.5V14.1875C11.375 15.5337 10.2837 16.625 8.9375 16.625H2.4375C1.09131 16.625 -5.8844e-08 15.5337 0 14.1875L2.48609e-07 8.5C3.07453e-07 7.15381 1.09131 6.0625 2.4375 6.0625L8.9375 6.0625C10.2837 6.0625 11.375 7.15381 11.375 8.5Z"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6875 3.625C4.79004 3.625 4.0625 4.35254 4.0625 5.25V6.875H2.4375V5.25C2.4375 3.45507 3.89257 2 5.6875 2C7.48243 2 8.9375 3.45507 8.9375 5.25V6.875H7.3125V5.25C7.3125 4.35254 6.58496 3.625 5.6875 3.625Z"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 10.125L6.5 12.5625H4.875L4.875 10.125H6.5Z"></path>
                <path d="M23.136 0.11C23.73 0.11 24.236 0.205333 24.654 0.396C25.072 0.586667 25.391 0.861666 25.611 1.221C25.831 1.58033 25.941 2.01667 25.941 2.53C25.941 3.04333 25.831 3.47967 25.611 3.839C25.391 4.19833 25.072 4.47333 24.654 4.664C24.236 4.85467 23.73 4.95 23.136 4.95H21.695V7.37H19.803V0.11H23.136ZM22.839 3.531C23.235 3.531 23.532 3.45033 23.73 3.289C23.9353 3.12033 24.038 2.86733 24.038 2.53C24.038 2.19267 23.9353 1.94333 23.73 1.782C23.532 1.61333 23.235 1.529 22.839 1.529H21.695V3.531H22.839Z"></path>
                <path d="M33.0094 7.37H31.0624L30.5564 5.731H28.0704L27.5534 7.37H25.6504L28.2024 0.11H30.4684L33.0094 7.37ZM28.4224 4.444H30.2044L29.3134 1.507L28.4224 4.444Z"></path>
                <path d="M36.5882 7.48C35.9429 7.48 35.3672 7.337 34.8612 7.051C34.3626 6.765 33.9739 6.34333 33.6952 5.786C33.4166 5.22867 33.2772 4.55033 33.2772 3.751C33.2772 2.96633 33.4239 2.29533 33.7172 1.738C34.0106 1.18067 34.4286 0.751667 34.9712 0.451C35.5212 0.150333 36.1666 0 36.9072 0C37.7286 0 38.3922 0.150333 38.8982 0.451C39.4042 0.744333 39.7966 1.21367 40.0752 1.859L38.3262 2.552C38.2309 2.178 38.0622 1.90667 37.8202 1.738C37.5782 1.56933 37.2776 1.485 36.9182 1.485C36.5589 1.485 36.2509 1.573 35.9942 1.749C35.7376 1.91767 35.5432 2.17067 35.4112 2.508C35.2792 2.838 35.2132 3.24867 35.2132 3.74C35.2132 4.25333 35.2792 4.68233 35.4112 5.027C35.5506 5.37167 35.7522 5.62833 36.0162 5.797C36.2876 5.95833 36.6212 6.039 37.0172 6.039C37.2299 6.039 37.4242 6.01333 37.6002 5.962C37.7762 5.91067 37.9302 5.83733 38.0622 5.742C38.1942 5.63933 38.2969 5.51467 38.3702 5.368C38.4436 5.214 38.4802 5.03433 38.4802 4.829V4.719H36.8192V3.454H40.0862V7.37H38.7992L38.6562 5.665L38.9642 5.929C38.8102 6.42767 38.5316 6.81267 38.1282 7.084C37.7322 7.348 37.2189 7.48 36.5882 7.48Z"></path>
                <path d="M48.1344 7.37H46.1874L45.6814 5.731H43.1954L42.6784 7.37H40.7754L43.3274 0.11H45.5934L48.1344 7.37ZM43.5474 4.444H45.3294L44.4384 1.507L43.5474 4.444Z"></path>
                <path d="M57.3828 0.11V7.37H55.7108V4.037L55.7658 1.804H55.7438L53.9508 7.37H52.4218L50.6288 1.804H50.6068L50.6618 4.037V7.37H48.9788V0.11H51.6738L52.8178 3.806L53.2248 5.346H53.2468L53.6648 3.817L54.7978 0.11H57.3828Z"></path>
                <path d="M58.9905 7.37V0.11H64.6445V1.573H60.8825V3.047H63.8745V4.422H60.8825V5.907H64.7875V7.37H58.9905Z"></path>
                <path d="M72.4749 0.11V7.37H70.3739L68.1189 3.443L67.5689 2.365H67.5579L67.6019 3.707V7.37H65.9299V0.11H68.0309L70.2859 4.037L70.8359 5.115H70.8469L70.8029 3.773V0.11H72.4749Z"></path>
                <path d="M80.1883 0.11V1.573H77.8233V7.37H75.9313V1.573H73.5553V0.11H80.1883Z"></path>
                <path d="M84.225 0C84.9583 0 85.589 0.150333 86.117 0.451C86.6523 0.744333 87.063 1.16967 87.349 1.727C87.635 2.28433 87.778 2.95533 87.778 3.74C87.778 4.52467 87.635 5.19567 87.349 5.753C87.063 6.31033 86.6523 6.73933 86.117 7.04C85.589 7.33333 84.9583 7.48 84.225 7.48C83.4917 7.48 82.8573 7.33333 82.322 7.04C81.7867 6.73933 81.376 6.31033 81.09 5.753C80.804 5.19567 80.661 4.52467 80.661 3.74C80.661 2.95533 80.804 2.28433 81.09 1.727C81.376 1.16967 81.7867 0.744333 82.322 0.451C82.8573 0.150333 83.4917 0 84.225 0ZM84.225 1.485C83.873 1.485 83.576 1.56933 83.334 1.738C83.092 1.90667 82.9087 2.15967 82.784 2.497C82.6593 2.827 82.597 3.24133 82.597 3.74C82.597 4.23133 82.6593 4.64567 82.784 4.983C82.9087 5.32033 83.092 5.57333 83.334 5.742C83.576 5.91067 83.873 5.995 84.225 5.995C84.577 5.995 84.8703 5.91067 85.105 5.742C85.347 5.57333 85.5303 5.32033 85.655 4.983C85.7797 4.64567 85.842 4.23133 85.842 3.74C85.842 3.24133 85.7797 2.827 85.655 2.497C85.5303 2.15967 85.347 1.90667 85.105 1.738C84.8703 1.56933 84.577 1.485 84.225 1.485Z"></path>
                <path d="M21.03 18.37V13.84C21.03 13.7067 21.03 13.57 21.03 13.43C21.0367 13.2833 21.0433 13.13 21.05 12.97C20.8233 13.19 20.5633 13.38 20.27 13.54C19.9833 13.6933 19.6867 13.8033 19.38 13.87L19.18 12.94C19.32 12.92 19.4833 12.8733 19.67 12.8C19.8567 12.7267 20.05 12.6333 20.25 12.52C20.45 12.4067 20.6333 12.2867 20.8 12.16C20.9667 12.0267 21.0967 11.8967 21.19 11.77H22.09V18.37H21.03Z"></path>
                <path d="M26.1634 18.47C25.3701 18.47 24.7468 18.1833 24.2934 17.61C23.8468 17.03 23.6234 16.1833 23.6234 15.07C23.6234 13.9567 23.8468 13.1133 24.2934 12.54C24.7468 11.96 25.3701 11.67 26.1634 11.67C26.9634 11.67 27.5868 11.96 28.0334 12.54C28.4868 13.1133 28.7134 13.9567 28.7134 15.07C28.7134 16.1833 28.4868 17.03 28.0334 17.61C27.5868 18.1833 26.9634 18.47 26.1634 18.47ZM26.1634 17.56C26.4834 17.56 26.7501 17.47 26.9634 17.29C27.1834 17.1033 27.3468 16.8267 27.4534 16.46C27.5668 16.0867 27.6234 15.6233 27.6234 15.07C27.6234 14.5167 27.5668 14.0567 27.4534 13.69C27.3468 13.3167 27.1834 13.04 26.9634 12.86C26.7501 12.6733 26.4834 12.58 26.1634 12.58C25.8434 12.58 25.5734 12.6733 25.3534 12.86C25.1401 13.04 24.9801 13.3167 24.8734 13.69C24.7668 14.0567 24.7134 14.5167 24.7134 15.07C24.7134 15.6233 24.7668 16.0867 24.8734 16.46C24.9801 16.8267 25.1401 17.1033 25.3534 17.29C25.5734 17.47 25.8434 17.56 26.1634 17.56Z"></path>
                <path d="M32.4427 18.47C31.6494 18.47 31.0261 18.1833 30.5727 17.61C30.1261 17.03 29.9027 16.1833 29.9027 15.07C29.9027 13.9567 30.1261 13.1133 30.5727 12.54C31.0261 11.96 31.6494 11.67 32.4427 11.67C33.2427 11.67 33.8661 11.96 34.3127 12.54C34.7661 13.1133 34.9927 13.9567 34.9927 15.07C34.9927 16.1833 34.7661 17.03 34.3127 17.61C33.8661 18.1833 33.2427 18.47 32.4427 18.47ZM32.4427 17.56C32.7627 17.56 33.0294 17.47 33.2427 17.29C33.4627 17.1033 33.6261 16.8267 33.7327 16.46C33.8461 16.0867 33.9027 15.6233 33.9027 15.07C33.9027 14.5167 33.8461 14.0567 33.7327 13.69C33.6261 13.3167 33.4627 13.04 33.2427 12.86C33.0294 12.6733 32.7627 12.58 32.4427 12.58C32.1227 12.58 31.8527 12.6733 31.6327 12.86C31.4194 13.04 31.2594 13.3167 31.1527 13.69C31.0461 14.0567 30.9927 14.5167 30.9927 15.07C30.9927 15.6233 31.0461 16.0867 31.1527 16.46C31.2594 16.8267 31.4194 17.1033 31.6327 17.29C31.8527 17.47 32.1227 17.56 32.4427 17.56Z"></path>
                <path d="M37.362 18.37L41.682 11.77H42.602L38.292 18.37H37.362ZM37.622 11.67C37.962 11.67 38.2554 11.7467 38.502 11.9C38.7554 12.0533 38.9487 12.2667 39.082 12.54C39.222 12.8133 39.292 13.1367 39.292 13.51C39.292 13.8767 39.222 14.2 39.082 14.48C38.9487 14.7533 38.7554 14.9667 38.502 15.12C38.2554 15.2733 37.962 15.35 37.622 15.35C37.2887 15.35 36.9954 15.2733 36.742 15.12C36.4887 14.9667 36.292 14.7533 36.152 14.48C36.0187 14.2 35.952 13.8767 35.952 13.51C35.952 13.1367 36.0187 12.8133 36.152 12.54C36.292 12.2667 36.4887 12.0533 36.742 11.9C36.9954 11.7467 37.2887 11.67 37.622 11.67ZM37.622 12.45C37.4554 12.45 37.312 12.4933 37.192 12.58C37.072 12.66 36.982 12.78 36.922 12.94C36.862 13.0933 36.832 13.2833 36.832 13.51C36.832 13.73 36.862 13.92 36.922 14.08C36.982 14.24 37.072 14.36 37.192 14.44C37.312 14.52 37.4554 14.56 37.622 14.56C37.7954 14.56 37.942 14.52 38.062 14.44C38.182 14.36 38.272 14.24 38.332 14.08C38.392 13.92 38.422 13.73 38.422 13.51C38.422 13.2833 38.392 13.0933 38.332 12.94C38.272 12.78 38.182 12.66 38.062 12.58C37.942 12.4933 37.7954 12.45 37.622 12.45ZM42.342 14.79C42.682 14.79 42.9754 14.8667 43.222 15.02C43.4754 15.1733 43.6687 15.39 43.802 15.67C43.942 15.9433 44.012 16.2633 44.012 16.63C44.012 17.0033 43.942 17.3267 43.802 17.6C43.6687 17.8733 43.4754 18.0867 43.222 18.24C42.9754 18.3933 42.682 18.47 42.342 18.47C42.0087 18.47 41.7154 18.3933 41.462 18.24C41.2087 18.0867 41.012 17.8733 40.872 17.6C40.7387 17.3267 40.672 17.0033 40.672 16.63C40.672 16.2633 40.7387 15.9433 40.872 15.67C41.012 15.39 41.2087 15.1733 41.462 15.02C41.7154 14.8667 42.0087 14.79 42.342 14.79ZM42.342 15.58C42.1754 15.58 42.032 15.62 41.912 15.7C41.792 15.78 41.702 15.9 41.642 16.06C41.582 16.2133 41.552 16.4033 41.552 16.63C41.552 16.85 41.582 17.04 41.642 17.2C41.702 17.36 41.792 17.4833 41.912 17.57C42.032 17.65 42.1754 17.69 42.342 17.69C42.5154 17.69 42.662 17.65 42.782 17.57C42.902 17.4833 42.992 17.36 43.052 17.2C43.112 17.04 43.142 16.85 43.142 16.63C43.142 16.41 43.112 16.22 43.052 16.06C42.992 15.9 42.902 15.78 42.782 15.7C42.662 15.62 42.5154 15.58 42.342 15.58Z"></path>
                <path d="M50.8628 11.67C51.4561 11.67 51.9695 11.7833 52.4028 12.01C52.8361 12.23 53.2028 12.5567 53.5028 12.99L52.7828 13.68C52.5295 13.2933 52.2428 13.0167 51.9228 12.85C51.6095 12.6767 51.2361 12.59 50.8028 12.59C50.4828 12.59 50.2195 12.6333 50.0128 12.72C49.8061 12.8067 49.6528 12.9233 49.5528 13.07C49.4595 13.21 49.4128 13.37 49.4128 13.55C49.4128 13.7567 49.4828 13.9367 49.6228 14.09C49.7695 14.2433 50.0395 14.3633 50.4328 14.45L51.7728 14.75C52.4128 14.89 52.8661 15.1033 53.1328 15.39C53.3995 15.6767 53.5328 16.04 53.5328 16.48C53.5328 16.8867 53.4228 17.24 53.2028 17.54C52.9828 17.84 52.6761 18.07 52.2828 18.23C51.8961 18.39 51.4395 18.47 50.9128 18.47C50.4461 18.47 50.0261 18.41 49.6528 18.29C49.2795 18.17 48.9528 18.0067 48.6728 17.8C48.3928 17.5933 48.1628 17.3567 47.9828 17.09L48.7228 16.35C48.8628 16.5833 49.0395 16.7933 49.2528 16.98C49.4661 17.16 49.7128 17.3 49.9928 17.4C50.2795 17.5 50.5961 17.55 50.9428 17.55C51.2495 17.55 51.5128 17.5133 51.7328 17.44C51.9595 17.3667 52.1295 17.26 52.2428 17.12C52.3628 16.9733 52.4228 16.8 52.4228 16.6C52.4228 16.4067 52.3561 16.2367 52.2228 16.09C52.0961 15.9433 51.8561 15.83 51.5028 15.75L50.0528 15.42C49.6528 15.3333 49.3228 15.21 49.0628 15.05C48.8028 14.89 48.6095 14.6967 48.4828 14.47C48.3561 14.2367 48.2928 13.9767 48.2928 13.69C48.2928 13.3167 48.3928 12.98 48.5928 12.68C48.7995 12.3733 49.0961 12.13 49.4828 11.95C49.8695 11.7633 50.3295 11.67 50.8628 11.67Z"></path>
                <path d="M55.0288 18.37V11.77H59.8088V12.69H56.0988V14.59H58.9988V15.49H56.0988V17.45H59.9488V18.37H55.0288Z"></path>
                <path d="M63.9491 18.47C63.3291 18.47 62.7924 18.3333 62.3391 18.06C61.8857 17.7867 61.5324 17.4 61.2791 16.9C61.0257 16.3933 60.8991 15.7833 60.8991 15.07C60.8991 14.37 61.0291 13.7667 61.2891 13.26C61.5557 12.7533 61.9291 12.3633 62.4091 12.09C62.8957 11.81 63.4524 11.67 64.0791 11.67C64.7657 11.67 65.3191 11.7967 65.7391 12.05C66.1657 12.3033 66.5057 12.6967 66.7591 13.23L65.7691 13.7C65.6424 13.3333 65.4324 13.06 65.1391 12.88C64.8524 12.6933 64.5024 12.6 64.0891 12.6C63.6757 12.6 63.3124 12.6967 62.9991 12.89C62.6924 13.0833 62.4524 13.3667 62.2791 13.74C62.1057 14.1067 62.0191 14.55 62.0191 15.07C62.0191 15.5967 62.0957 16.0467 62.2491 16.42C62.4024 16.7867 62.6324 17.0667 62.9391 17.26C63.2524 17.4533 63.6357 17.55 64.0891 17.55C64.3357 17.55 64.5657 17.52 64.7791 17.46C64.9924 17.3933 65.1791 17.3 65.3391 17.18C65.4991 17.0533 65.6224 16.8967 65.7091 16.71C65.8024 16.5167 65.8491 16.29 65.8491 16.03V15.84H63.9291V14.97H66.7991V18.37H65.9991L65.9391 17.04L66.1391 17.14C65.9791 17.56 65.7124 17.8867 65.3391 18.12C64.9724 18.3533 64.5091 18.47 63.9491 18.47Z"></path>
                <path d="M73.7654 11.77V15.84C73.7654 16.7133 73.5354 17.37 73.0754 17.81C72.6154 18.25 71.9454 18.47 71.0654 18.47C70.1987 18.47 69.5321 18.25 69.0654 17.81C68.6054 17.37 68.3754 16.7133 68.3754 15.84V11.77H69.4454V15.71C69.4454 16.33 69.5787 16.79 69.8454 17.09C70.112 17.39 70.5187 17.54 71.0654 17.54C71.6187 17.54 72.0287 17.39 72.2954 17.09C72.5621 16.79 72.6954 16.33 72.6954 15.71V11.77H73.7654Z"></path>
                <path d="M78.2852 11.77C78.9919 11.77 79.5519 11.9467 79.9652 12.3C80.3852 12.6533 80.5952 13.13 80.5952 13.73C80.5952 14.35 80.3852 14.83 79.9652 15.17C79.5519 15.5033 78.9919 15.67 78.2852 15.67L78.1852 15.73H76.6552V18.37H75.5952V11.77H78.2852ZM78.2052 14.84C78.6386 14.84 78.9586 14.7533 79.1652 14.58C79.3786 14.4 79.4852 14.1267 79.4852 13.76C79.4852 13.4 79.3786 13.13 79.1652 12.95C78.9586 12.77 78.6386 12.68 78.2052 12.68H76.6552V14.84H78.2052ZM78.8352 15.06L80.9852 18.37H79.7552L77.9152 15.48L78.8352 15.06Z"></path>
                <path d="M84.9954 11.67C85.6354 11.67 86.1887 11.8067 86.6554 12.08C87.122 12.3533 87.482 12.7433 87.7354 13.25C87.9887 13.7567 88.1154 14.3633 88.1154 15.07C88.1154 15.7767 87.9887 16.3833 87.7354 16.89C87.482 17.3967 87.122 17.7867 86.6554 18.06C86.1887 18.3333 85.6354 18.47 84.9954 18.47C84.3621 18.47 83.812 18.3333 83.3454 18.06C82.8787 17.7867 82.5187 17.3967 82.2654 16.89C82.0121 16.3833 81.8854 15.7767 81.8854 15.07C81.8854 14.3633 82.0121 13.7567 82.2654 13.25C82.5187 12.7433 82.8787 12.3533 83.3454 12.08C83.812 11.8067 84.3621 11.67 84.9954 11.67ZM84.9954 12.6C84.5821 12.6 84.2254 12.6967 83.9254 12.89C83.6321 13.0833 83.4054 13.3633 83.2454 13.73C83.0854 14.0967 83.0054 14.5433 83.0054 15.07C83.0054 15.59 83.0854 16.0367 83.2454 16.41C83.4054 16.7767 83.6321 17.0567 83.9254 17.25C84.2254 17.4433 84.5821 17.54 84.9954 17.54C85.4154 17.54 85.7721 17.4433 86.0654 17.25C86.3654 17.0567 86.5954 16.7767 86.7554 16.41C86.9154 16.0367 86.9954 15.59 86.9954 15.07C86.9954 14.5433 86.9154 14.0967 86.7554 13.73C86.5954 13.3633 86.3654 13.0833 86.0654 12.89C85.7721 12.6967 85.4154 12.6 84.9954 12.6Z"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="container">
          <div class="row" id="alterarGrid">
            <div class="col-12">

              <div class="alert alert-danger" role="alert" v-if="orca_expired == true">
                Esse orçamento já está expirado, entre em contato com seu vendedor para obter um orçamento atualizado!
              </div>
            </div>

            <div class="col-12 col-md-7 mb-4">
              <div class="row cardItem">
                <div class="col-10" @click="dadosPessoais = !dadosPessoais">
                  <span class="fontTitle"><i class="fas fa-user mr-2"></i>Dados pessoais</span>
                </div>
                <div class="col-2 text-right" @click="dadosPessoais = !dadosPessoais">
                  <span class="fontTitle">
                    <i v-if="dadosPessoais" class="fas fa-arrow-up"></i><i v-if="!dadosPessoais" class="fas fa-arrow-down"></i>
                  </span>
                </div>

                <div class="col-12" v-if="dadosPessoais">
                  <div class="row mb-2">
                    <div class="col-12 mt-2" v-if="orca_cliente == false">
                      <label>Nome completo:</label>
                      <input type="text" class="form-control" v-model="nomeCompleto">
                    </div>

                    <div class="col-6 mt-2" v-if="orca_cliente == true">
                      <label>Nome:</label>
                      <input type="text" class="form-control" v-model="nome">
                    </div>

                    <div class="col-6 mt-2" v-if="orca_cliente == true">
                      <label>Sobrenome:</label>
                      <input type="text" class="form-control" v-model="sobrenome">
                    </div>

                    <div class="col-12 mt-2">
                      <label>E-mail:</label>
                      <input type="text" class="form-control" v-model="data.cliente.email" @blur="validarEmail()">
                    </div>

                    <div class="col-6 mt-2" v-if="orca_cliente == true">
                      <label>Senha:</label>
                      <input :type="showPassword ? 'text' : 'password'" class="form-control" v-model="password">
                      <span class="eyeInput" @click="showPassword = !showPassword">
                        <i class="fas fa-eye" v-if="showPassword"></i>
                        <i class="fas fa-eye-slash" v-else></i>
                      </span>
                    </div>

                    <div class="col-6 mt-2" v-if="orca_cliente == true">
                      <label>Repita a senha:</label>
                      <input :type="reShowPassword ? 'text' : 'password'" class="form-control" v-model="repassword">
                      <span class="eyeInput" @click="reShowPassword = !reShowPassword">
                        <i class="fas fa-eye" v-if="reShowPassword"></i>
                        <i class="fas fa-eye-slash" v-else></i>
                      </span>
                    </div>

                    <div class="col-12 col-md-6 mt-2">
                      <label>WhatsApp:</label>
                      <input type="text" class="form-control" v-model="whatsapp" v-mask="['(##) ####-####', '(##) # ####-####']">
                    </div>

                    <div class="col-12 col-md-6 mt-2" v-if="orca_cliente == false">
                      <label>CPF/CNPJ:</label>
                      <input type="text" class="form-control" v-model="data.cliente.cpf_cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']">
                    </div>

                    <div class="col-12 col-md-6 mt-2" v-else>
                      <label>CPF:</label>
                      <input type="text" class="form-control" v-model="data.cliente.cpf_cnpj" v-mask="'###.###.###-##'" @blur="validarCpf()">
                    </div>

                    <div class="col-12 text-center mt-4">
                      <button class="btn-avancar blockBtnShow" @click="avancarMethods('pessoais')" v-if="orca_cliente == false">CONTINUAR<i class="fas fa-arrow-right ml-2"></i></button>
                      <button class="btn-avancar blockBtnShow" @click="criarCliente()" v-else>CRIAR CONTA</button>
                    </div>

                    <div class="col-12" v-if="orca_cliente == true">
                      <span style="color:red">Para finalizar o pedido, crie uma conta primeiro!</span>
                    </div>

                  </div>
                </div>
              </div>

              <div class="row cardItem mt-4">
                <div class="col-10" @click="dadosEntrega = !dadosEntrega">
                  <span class="fontTitle"><i class="fas fa-truck mr-2"></i>Opções de entrega</span>
                </div>
                <div class="col-2 text-right" @click="dadosEntrega = !dadosEntrega">
                  <span class="fontTitle">
                    <i v-if="dadosEntrega" class="fas fa-arrow-up"></i><i v-if="!dadosEntrega" class="fas fa-arrow-down"></i>
                  </span>
                </div>

                <div class="col-12" v-if="dadosEntrega">
                  <div class="row mb-2">

                    <div class="col-12 col-md-6 text-center mt-4 cursor-pointer" @click="selectFrete('L', false)" v-if="data.orcamento.frete_orcamento[0].retira_loja == true">
                      <input type="radio" class="mr-2" checked v-if="tipoFrete == 'L'">
                      <span v-html="printRadio" v-if="tipoFrete != 'L'"></span>
                      <label>Retirar na loja</label>
                      <p class="titleEnd">Endereço da loja</p>
                      <div class="cardEndHeader">
                        <div class="cardEnd">
                          <p>{{montarEndLoja(data.lojista)}}</p>
                          <p class="mt-2">
                            Retire os itens do pedido, após {{data.orcamento.frete_orcamento[0].retira_loja_qtd}} 
                            {{data.orcamento.frete_orcamento[0].retira_loja_tempo}} do pagamento confirmado.
                          </p>
                          <p class="mt-2">Valor: <b>GRÁTIS</b></p>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6 text-center mt-4 cursor-pointer" @click="selectFrete('F', true)" v-if="data.orcamento.frete_orcamento[0].loja_entrega == true">
                      <input type="radio" class="mr-2" checked v-if="tipoFrete == 'F'">
                      <span v-html="printRadio" v-if="tipoFrete != 'F'"></span>
                      <label>Frete para entregar</label>
                      <p class="titleEnd">Endereço do cliente</p>
                      <div class="cardEndHeader">
                        <div class="cardEnd">
                          <p>{{enderecoCompleto}}</p>
                          <p class="mt-2">
                            O pedido será enviado em até {{data.orcamento.frete_orcamento[0].loja_entrega_qtd}} 
                            {{data.orcamento.frete_orcamento[0].loja_entrega_tempo}}, após o pagamento confirmado.
                          </p>
                          <p class="mt-2">Valor: <b>R$ {{data.orcamento.frete_orcamento[0].loja_entrega_frete}}</b></p>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 text-center mt-4">
                      <button class="btn-avancar blockBtnShow" @click="avancarMethods('frete')">CONTINUAR<i class="fas fa-arrow-right ml-2"></i></button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row cardItem mt-4">
                <div class="col-10" @click="dadosPagamento = !dadosPagamento">
                  <span class="fontTitle"><i class="fas fa-money-check mr-2"></i>Opções de pagamento</span>
                </div>
                <div class="col-2 text-right" @click="dadosPagamento = !dadosPagamento">
                  <span class="fontTitle">
                    <i v-if="dadosPagamento" class="fas fa-arrow-up"></i><i v-if="!dadosPagamento" class="fas fa-arrow-down"></i>
                  </span>
                </div>

                <div class="col-12" v-if="dadosPagamento">
                  <div class="row mb-2">

                    <div class="col-12 mt-4">
                      <b-button v-if="data.orcamento.pagamento_orcamento[0].cartao_credito == true"
                        variant="dark" :class="pagamentoSelecionado == 'C' ? 'success' : 'mb-2'" block @click="pagamentoSelecionado = 'C', selectCard()">Cartão de crédito
                      </b-button>

                      <div class="row mb-2 mt-5" :style="mostrarCard == true ? 'display:block' : 'display:none'">
                        <div class="col-12 formatCardCenter">
                          <div class="card-wrapper mb-5"></div>
                        </div>

                        <div id="cc-form" class="col-12 mb-3">

                          <div class="row">
                            <div class="col-12 col-md-12">
                              <label>Número do cartão</label>
                              <input class="form-control mb-3" id="cc-number" type="text" name="number" v-model="number" placeholder="xxxx - xxxx - xxxx - xxxx">
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-12 col-md-6">
                              <label>Nome</label>
                              <input class="form-control mb-3" id="ccName" type="text" name="ccName" v-model="ccName" placeholder="Digite o seu nome">
                            </div>

                            <div class="col-12 col-md-6">
                              <label>Sobrenome</label>
                              <input class="form-control mb-3" id="last-name" type="text" name="last-name" v-model="lastname" placeholder="Digite o seu sobrenome">
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-6 col-md-4">
                              <label>Mês de expiração</label>
                              <input class="form-control mb-3" id="cc-expiration" type="text" name="expiry" v-model="month" placeholder="xx"  maxlength="2">
                            </div>

                            <div class="col-6 col-md-4">
                              <label>Ano de expiração</label>
                              <input class="form-control mb-3" id="cc-expiration" type="text" name="expiry" v-model="year" placeholder="xxxx" maxlength="4">
                            </div>

                            <div class="col-12 col-md-4">
                              <label>CVV</label>
                              <input class="form-control mb-3" id="cc-cvv" type="text" name="cvc" v-model="cvv" placeholder="xxx" maxlength="4" @focus="validCVC('back')" @blur="validCVC('front')">
                            </div>

                            <div class="col-12 col-md-12">
                              <label>Selecione as parcelas</label>
                              <select class="form-control" v-model="months" id="months">
                                <option value="">Selecione a quantidade de parcela(s)</option>
                                <option v-for="(installments, index) in data.orcamento.pagamento_orcamento[0].cartao_parcela" :key="index" :value="index + 1">
                                  Pagamento em {{ index + 1 }}x de {{valorParcela(index)}}
                                </option>
                              </select>
                            </div>

                            <div class="col-12 text-center mt-2">
                              <button class="btn-avancar blockBtn" @click="avancarMethods('pagamento')" :disabled="orca_cliente == true">FINALIZAR<i class="fas fa-arrow-right ml-2"></i></button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <b-button v-if="data.orcamento.pagamento_orcamento[0].pix == true"
                        variant="dark" :class="pagamentoSelecionado == 'P' ? 'success' : ''" block @click="pagamentoSelecionado = 'P', mostrarCard = false">Pix
                      </b-button>

                      <b-button v-if="data.orcamento.pagamento_orcamento[0].boleto == true"
                        variant="dark" :class="pagamentoSelecionado == 'B' ? 'success' : ''" block @click="pagamentoSelecionado = 'B', mostrarCard = false">Boleto
                      </b-button>

                      <b-button v-if="data.orcamento.pagamento_orcamento[0].pagamento_entrega == true"
                        variant="dark" :class="pagamentoSelecionado == 'E' ? 'success' : ''" block @click="pagamentoSelecionado = 'E', mostrarCard = false">Pagamento na retirada ou na loja
                      </b-button>

                      <div class="col-12 text-center mt-2" v-if="pagamentoSelecionado != 'C' && pagamentoSelecionado != ''">
                        <button class="btn-avancar blockBtn" @click="avancarMethods('pagamento')" :disabled="orca_cliente == true">FINALIZAR<i class="fas fa-arrow-right ml-2"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-5">
              <div class="row cardItemRow cardItem">
                <div class="col-12">
                  <span class="fontTitle"><i class="fas fa-th-list mr-2"></i>Resumo</span>
                </div>
                
                <div class="col-12">

                  <div class="row cardProduto mt-2" v-for="(item, i) in data.orcamento.produto_orcamento" :key="i">
                    <div class="col-3 cardProdutoImg">
                      <img :src="montarUrl(item.origem, item.img)" class="imgProduto" :alt="item.produto">
                    </div>
                    <div class="col-9">
                      <p style="font-size: 14px;padding-bottom: 10px;">{{item.produto}}</p>
                      <div class="row fontSelectPro">
                        <div class="col-6">
                          <span><b>Preço: R$ {{item.preco}}</b></span>
                        </div>
                        <div class="col-6 text-center" v-if="item.qtd_alt == true">
                          <div class="row">
                            <div class="col-4 selecionaQtd" @click="somaQtd(item, '-')">-</div>
                            <div class="col-4 selecionaQtd">{{item.qtd}}</div>
                            <div class="col-4 selecionaQtd" @click="somaQtd(item, '+')">+</div>
                          </div>
                        </div>
                        <div class="col-6 text-right" v-else>
                          <p class="ml-2"><b>Qtd: {{item.qtd}}</b></p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="col-12 mt-4 cardSoma">
                  <div class="row">
                    <div class="col-6">
                      <b>Produtos</b>
                    </div>
                    <div class="col-6 text-right">
                      <span>{{valorTotal != null ? insertDot(valorSubtotal, true) : 'R$  0,00'}}</span>
                    </div>
                  </div>

                  <div v-if="valueDiscountPaymentForm > 0" class="row">
                    <div class="col-6">
                      <b>Desconto</b>
                    </div>
                    <div class="col-6 text-right">
                      <span style="color: red;"> - {{ insertDot(valueDiscountPaymentForm, true) }}</span>
                    </div>
                  </div>

                  <div class="row mt-1">
                    <div class="col-6">
                      <b>Frete</b>
                    </div>
                    <div class="col-6 text-right">
                      <span v-if="frete == true">R$ {{data.orcamento.frete_orcamento[0].loja_entrega_frete}}</span>
                      <span v-else>R$ 0,00</span>
                    </div>
                  </div>
                  
                  <div v-if="!valueDiscount" class="row mt-1 mx-1">
                    <b-input-group prepend="Cupom de desconto" class="mt-3">
                      <b-form-input v-model="coupon" @keyup.enter="applyCoupom()" placeholder="inserir cupom"/>
                      <b-input-group-append>
                        <b-button @click="applyCoupom()" variant="success">Aplicar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <div v-else class="row mt-1">
                    <div class="col-6">
                      <b>Cupom de desconto</b>
                    </div>
                    <div class="col-6 text-right">
                      <span>{{ insertDot(valueDiscount, true)}}</span>
                    </div>
                  </div>

                  <div class="row mt-3 totalFinal">
                    <div class="col-6">
                      <b>Total</b>
                    </div>
                    <div class="col-6 text-right">
                      <span>{{valorTotal != null ? insertDot(valorTotal, true) : '0,00'}}</span>
                    </div>
                  </div>

                  <div class="row mt-2">
                     <div class="col-12 text-center mt-2">
                        <button class="btn-avancar blockBtnShow blockBtnHide" @click="avancarMethods('pagamento')" :disabled="orca_cliente == true">FINALIZAR<i class="fas fa-arrow-right ml-2"></i></button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center mt-4">
              <svg width="89" height="19" viewBox="0 0 89 19" fill="#898792" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 14.1875V8.5C9.75 8.05127 9.38623 7.6875 8.9375 7.6875L2.4375 7.6875C1.98877 7.6875 1.625 8.05127 1.625 8.5L1.625 14.1875C1.625 14.6362 1.98877 15 2.4375 15H8.9375C9.38623 15 9.75 14.6362 9.75 14.1875ZM11.375 8.5V14.1875C11.375 15.5337 10.2837 16.625 8.9375 16.625H2.4375C1.09131 16.625 -5.8844e-08 15.5337 0 14.1875L2.48609e-07 8.5C3.07453e-07 7.15381 1.09131 6.0625 2.4375 6.0625L8.9375 6.0625C10.2837 6.0625 11.375 7.15381 11.375 8.5Z"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6875 3.625C4.79004 3.625 4.0625 4.35254 4.0625 5.25V6.875H2.4375V5.25C2.4375 3.45507 3.89257 2 5.6875 2C7.48243 2 8.9375 3.45507 8.9375 5.25V6.875H7.3125V5.25C7.3125 4.35254 6.58496 3.625 5.6875 3.625Z"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 10.125L6.5 12.5625H4.875L4.875 10.125H6.5Z"></path>
                <path d="M23.136 0.11C23.73 0.11 24.236 0.205333 24.654 0.396C25.072 0.586667 25.391 0.861666 25.611 1.221C25.831 1.58033 25.941 2.01667 25.941 2.53C25.941 3.04333 25.831 3.47967 25.611 3.839C25.391 4.19833 25.072 4.47333 24.654 4.664C24.236 4.85467 23.73 4.95 23.136 4.95H21.695V7.37H19.803V0.11H23.136ZM22.839 3.531C23.235 3.531 23.532 3.45033 23.73 3.289C23.9353 3.12033 24.038 2.86733 24.038 2.53C24.038 2.19267 23.9353 1.94333 23.73 1.782C23.532 1.61333 23.235 1.529 22.839 1.529H21.695V3.531H22.839Z"></path>
                <path d="M33.0094 7.37H31.0624L30.5564 5.731H28.0704L27.5534 7.37H25.6504L28.2024 0.11H30.4684L33.0094 7.37ZM28.4224 4.444H30.2044L29.3134 1.507L28.4224 4.444Z"></path>
                <path d="M36.5882 7.48C35.9429 7.48 35.3672 7.337 34.8612 7.051C34.3626 6.765 33.9739 6.34333 33.6952 5.786C33.4166 5.22867 33.2772 4.55033 33.2772 3.751C33.2772 2.96633 33.4239 2.29533 33.7172 1.738C34.0106 1.18067 34.4286 0.751667 34.9712 0.451C35.5212 0.150333 36.1666 0 36.9072 0C37.7286 0 38.3922 0.150333 38.8982 0.451C39.4042 0.744333 39.7966 1.21367 40.0752 1.859L38.3262 2.552C38.2309 2.178 38.0622 1.90667 37.8202 1.738C37.5782 1.56933 37.2776 1.485 36.9182 1.485C36.5589 1.485 36.2509 1.573 35.9942 1.749C35.7376 1.91767 35.5432 2.17067 35.4112 2.508C35.2792 2.838 35.2132 3.24867 35.2132 3.74C35.2132 4.25333 35.2792 4.68233 35.4112 5.027C35.5506 5.37167 35.7522 5.62833 36.0162 5.797C36.2876 5.95833 36.6212 6.039 37.0172 6.039C37.2299 6.039 37.4242 6.01333 37.6002 5.962C37.7762 5.91067 37.9302 5.83733 38.0622 5.742C38.1942 5.63933 38.2969 5.51467 38.3702 5.368C38.4436 5.214 38.4802 5.03433 38.4802 4.829V4.719H36.8192V3.454H40.0862V7.37H38.7992L38.6562 5.665L38.9642 5.929C38.8102 6.42767 38.5316 6.81267 38.1282 7.084C37.7322 7.348 37.2189 7.48 36.5882 7.48Z"></path>
                <path d="M48.1344 7.37H46.1874L45.6814 5.731H43.1954L42.6784 7.37H40.7754L43.3274 0.11H45.5934L48.1344 7.37ZM43.5474 4.444H45.3294L44.4384 1.507L43.5474 4.444Z"></path>
                <path d="M57.3828 0.11V7.37H55.7108V4.037L55.7658 1.804H55.7438L53.9508 7.37H52.4218L50.6288 1.804H50.6068L50.6618 4.037V7.37H48.9788V0.11H51.6738L52.8178 3.806L53.2248 5.346H53.2468L53.6648 3.817L54.7978 0.11H57.3828Z"></path>
                <path d="M58.9905 7.37V0.11H64.6445V1.573H60.8825V3.047H63.8745V4.422H60.8825V5.907H64.7875V7.37H58.9905Z"></path>
                <path d="M72.4749 0.11V7.37H70.3739L68.1189 3.443L67.5689 2.365H67.5579L67.6019 3.707V7.37H65.9299V0.11H68.0309L70.2859 4.037L70.8359 5.115H70.8469L70.8029 3.773V0.11H72.4749Z"></path>
                <path d="M80.1883 0.11V1.573H77.8233V7.37H75.9313V1.573H73.5553V0.11H80.1883Z"></path>
                <path d="M84.225 0C84.9583 0 85.589 0.150333 86.117 0.451C86.6523 0.744333 87.063 1.16967 87.349 1.727C87.635 2.28433 87.778 2.95533 87.778 3.74C87.778 4.52467 87.635 5.19567 87.349 5.753C87.063 6.31033 86.6523 6.73933 86.117 7.04C85.589 7.33333 84.9583 7.48 84.225 7.48C83.4917 7.48 82.8573 7.33333 82.322 7.04C81.7867 6.73933 81.376 6.31033 81.09 5.753C80.804 5.19567 80.661 4.52467 80.661 3.74C80.661 2.95533 80.804 2.28433 81.09 1.727C81.376 1.16967 81.7867 0.744333 82.322 0.451C82.8573 0.150333 83.4917 0 84.225 0ZM84.225 1.485C83.873 1.485 83.576 1.56933 83.334 1.738C83.092 1.90667 82.9087 2.15967 82.784 2.497C82.6593 2.827 82.597 3.24133 82.597 3.74C82.597 4.23133 82.6593 4.64567 82.784 4.983C82.9087 5.32033 83.092 5.57333 83.334 5.742C83.576 5.91067 83.873 5.995 84.225 5.995C84.577 5.995 84.8703 5.91067 85.105 5.742C85.347 5.57333 85.5303 5.32033 85.655 4.983C85.7797 4.64567 85.842 4.23133 85.842 3.74C85.842 3.24133 85.7797 2.827 85.655 2.497C85.5303 2.15967 85.347 1.90667 85.105 1.738C84.8703 1.56933 84.577 1.485 84.225 1.485Z"></path>
                <path d="M21.03 18.37V13.84C21.03 13.7067 21.03 13.57 21.03 13.43C21.0367 13.2833 21.0433 13.13 21.05 12.97C20.8233 13.19 20.5633 13.38 20.27 13.54C19.9833 13.6933 19.6867 13.8033 19.38 13.87L19.18 12.94C19.32 12.92 19.4833 12.8733 19.67 12.8C19.8567 12.7267 20.05 12.6333 20.25 12.52C20.45 12.4067 20.6333 12.2867 20.8 12.16C20.9667 12.0267 21.0967 11.8967 21.19 11.77H22.09V18.37H21.03Z"></path>
                <path d="M26.1634 18.47C25.3701 18.47 24.7468 18.1833 24.2934 17.61C23.8468 17.03 23.6234 16.1833 23.6234 15.07C23.6234 13.9567 23.8468 13.1133 24.2934 12.54C24.7468 11.96 25.3701 11.67 26.1634 11.67C26.9634 11.67 27.5868 11.96 28.0334 12.54C28.4868 13.1133 28.7134 13.9567 28.7134 15.07C28.7134 16.1833 28.4868 17.03 28.0334 17.61C27.5868 18.1833 26.9634 18.47 26.1634 18.47ZM26.1634 17.56C26.4834 17.56 26.7501 17.47 26.9634 17.29C27.1834 17.1033 27.3468 16.8267 27.4534 16.46C27.5668 16.0867 27.6234 15.6233 27.6234 15.07C27.6234 14.5167 27.5668 14.0567 27.4534 13.69C27.3468 13.3167 27.1834 13.04 26.9634 12.86C26.7501 12.6733 26.4834 12.58 26.1634 12.58C25.8434 12.58 25.5734 12.6733 25.3534 12.86C25.1401 13.04 24.9801 13.3167 24.8734 13.69C24.7668 14.0567 24.7134 14.5167 24.7134 15.07C24.7134 15.6233 24.7668 16.0867 24.8734 16.46C24.9801 16.8267 25.1401 17.1033 25.3534 17.29C25.5734 17.47 25.8434 17.56 26.1634 17.56Z"></path>
                <path d="M32.4427 18.47C31.6494 18.47 31.0261 18.1833 30.5727 17.61C30.1261 17.03 29.9027 16.1833 29.9027 15.07C29.9027 13.9567 30.1261 13.1133 30.5727 12.54C31.0261 11.96 31.6494 11.67 32.4427 11.67C33.2427 11.67 33.8661 11.96 34.3127 12.54C34.7661 13.1133 34.9927 13.9567 34.9927 15.07C34.9927 16.1833 34.7661 17.03 34.3127 17.61C33.8661 18.1833 33.2427 18.47 32.4427 18.47ZM32.4427 17.56C32.7627 17.56 33.0294 17.47 33.2427 17.29C33.4627 17.1033 33.6261 16.8267 33.7327 16.46C33.8461 16.0867 33.9027 15.6233 33.9027 15.07C33.9027 14.5167 33.8461 14.0567 33.7327 13.69C33.6261 13.3167 33.4627 13.04 33.2427 12.86C33.0294 12.6733 32.7627 12.58 32.4427 12.58C32.1227 12.58 31.8527 12.6733 31.6327 12.86C31.4194 13.04 31.2594 13.3167 31.1527 13.69C31.0461 14.0567 30.9927 14.5167 30.9927 15.07C30.9927 15.6233 31.0461 16.0867 31.1527 16.46C31.2594 16.8267 31.4194 17.1033 31.6327 17.29C31.8527 17.47 32.1227 17.56 32.4427 17.56Z"></path>
                <path d="M37.362 18.37L41.682 11.77H42.602L38.292 18.37H37.362ZM37.622 11.67C37.962 11.67 38.2554 11.7467 38.502 11.9C38.7554 12.0533 38.9487 12.2667 39.082 12.54C39.222 12.8133 39.292 13.1367 39.292 13.51C39.292 13.8767 39.222 14.2 39.082 14.48C38.9487 14.7533 38.7554 14.9667 38.502 15.12C38.2554 15.2733 37.962 15.35 37.622 15.35C37.2887 15.35 36.9954 15.2733 36.742 15.12C36.4887 14.9667 36.292 14.7533 36.152 14.48C36.0187 14.2 35.952 13.8767 35.952 13.51C35.952 13.1367 36.0187 12.8133 36.152 12.54C36.292 12.2667 36.4887 12.0533 36.742 11.9C36.9954 11.7467 37.2887 11.67 37.622 11.67ZM37.622 12.45C37.4554 12.45 37.312 12.4933 37.192 12.58C37.072 12.66 36.982 12.78 36.922 12.94C36.862 13.0933 36.832 13.2833 36.832 13.51C36.832 13.73 36.862 13.92 36.922 14.08C36.982 14.24 37.072 14.36 37.192 14.44C37.312 14.52 37.4554 14.56 37.622 14.56C37.7954 14.56 37.942 14.52 38.062 14.44C38.182 14.36 38.272 14.24 38.332 14.08C38.392 13.92 38.422 13.73 38.422 13.51C38.422 13.2833 38.392 13.0933 38.332 12.94C38.272 12.78 38.182 12.66 38.062 12.58C37.942 12.4933 37.7954 12.45 37.622 12.45ZM42.342 14.79C42.682 14.79 42.9754 14.8667 43.222 15.02C43.4754 15.1733 43.6687 15.39 43.802 15.67C43.942 15.9433 44.012 16.2633 44.012 16.63C44.012 17.0033 43.942 17.3267 43.802 17.6C43.6687 17.8733 43.4754 18.0867 43.222 18.24C42.9754 18.3933 42.682 18.47 42.342 18.47C42.0087 18.47 41.7154 18.3933 41.462 18.24C41.2087 18.0867 41.012 17.8733 40.872 17.6C40.7387 17.3267 40.672 17.0033 40.672 16.63C40.672 16.2633 40.7387 15.9433 40.872 15.67C41.012 15.39 41.2087 15.1733 41.462 15.02C41.7154 14.8667 42.0087 14.79 42.342 14.79ZM42.342 15.58C42.1754 15.58 42.032 15.62 41.912 15.7C41.792 15.78 41.702 15.9 41.642 16.06C41.582 16.2133 41.552 16.4033 41.552 16.63C41.552 16.85 41.582 17.04 41.642 17.2C41.702 17.36 41.792 17.4833 41.912 17.57C42.032 17.65 42.1754 17.69 42.342 17.69C42.5154 17.69 42.662 17.65 42.782 17.57C42.902 17.4833 42.992 17.36 43.052 17.2C43.112 17.04 43.142 16.85 43.142 16.63C43.142 16.41 43.112 16.22 43.052 16.06C42.992 15.9 42.902 15.78 42.782 15.7C42.662 15.62 42.5154 15.58 42.342 15.58Z"></path>
                <path d="M50.8628 11.67C51.4561 11.67 51.9695 11.7833 52.4028 12.01C52.8361 12.23 53.2028 12.5567 53.5028 12.99L52.7828 13.68C52.5295 13.2933 52.2428 13.0167 51.9228 12.85C51.6095 12.6767 51.2361 12.59 50.8028 12.59C50.4828 12.59 50.2195 12.6333 50.0128 12.72C49.8061 12.8067 49.6528 12.9233 49.5528 13.07C49.4595 13.21 49.4128 13.37 49.4128 13.55C49.4128 13.7567 49.4828 13.9367 49.6228 14.09C49.7695 14.2433 50.0395 14.3633 50.4328 14.45L51.7728 14.75C52.4128 14.89 52.8661 15.1033 53.1328 15.39C53.3995 15.6767 53.5328 16.04 53.5328 16.48C53.5328 16.8867 53.4228 17.24 53.2028 17.54C52.9828 17.84 52.6761 18.07 52.2828 18.23C51.8961 18.39 51.4395 18.47 50.9128 18.47C50.4461 18.47 50.0261 18.41 49.6528 18.29C49.2795 18.17 48.9528 18.0067 48.6728 17.8C48.3928 17.5933 48.1628 17.3567 47.9828 17.09L48.7228 16.35C48.8628 16.5833 49.0395 16.7933 49.2528 16.98C49.4661 17.16 49.7128 17.3 49.9928 17.4C50.2795 17.5 50.5961 17.55 50.9428 17.55C51.2495 17.55 51.5128 17.5133 51.7328 17.44C51.9595 17.3667 52.1295 17.26 52.2428 17.12C52.3628 16.9733 52.4228 16.8 52.4228 16.6C52.4228 16.4067 52.3561 16.2367 52.2228 16.09C52.0961 15.9433 51.8561 15.83 51.5028 15.75L50.0528 15.42C49.6528 15.3333 49.3228 15.21 49.0628 15.05C48.8028 14.89 48.6095 14.6967 48.4828 14.47C48.3561 14.2367 48.2928 13.9767 48.2928 13.69C48.2928 13.3167 48.3928 12.98 48.5928 12.68C48.7995 12.3733 49.0961 12.13 49.4828 11.95C49.8695 11.7633 50.3295 11.67 50.8628 11.67Z"></path>
                <path d="M55.0288 18.37V11.77H59.8088V12.69H56.0988V14.59H58.9988V15.49H56.0988V17.45H59.9488V18.37H55.0288Z"></path>
                <path d="M63.9491 18.47C63.3291 18.47 62.7924 18.3333 62.3391 18.06C61.8857 17.7867 61.5324 17.4 61.2791 16.9C61.0257 16.3933 60.8991 15.7833 60.8991 15.07C60.8991 14.37 61.0291 13.7667 61.2891 13.26C61.5557 12.7533 61.9291 12.3633 62.4091 12.09C62.8957 11.81 63.4524 11.67 64.0791 11.67C64.7657 11.67 65.3191 11.7967 65.7391 12.05C66.1657 12.3033 66.5057 12.6967 66.7591 13.23L65.7691 13.7C65.6424 13.3333 65.4324 13.06 65.1391 12.88C64.8524 12.6933 64.5024 12.6 64.0891 12.6C63.6757 12.6 63.3124 12.6967 62.9991 12.89C62.6924 13.0833 62.4524 13.3667 62.2791 13.74C62.1057 14.1067 62.0191 14.55 62.0191 15.07C62.0191 15.5967 62.0957 16.0467 62.2491 16.42C62.4024 16.7867 62.6324 17.0667 62.9391 17.26C63.2524 17.4533 63.6357 17.55 64.0891 17.55C64.3357 17.55 64.5657 17.52 64.7791 17.46C64.9924 17.3933 65.1791 17.3 65.3391 17.18C65.4991 17.0533 65.6224 16.8967 65.7091 16.71C65.8024 16.5167 65.8491 16.29 65.8491 16.03V15.84H63.9291V14.97H66.7991V18.37H65.9991L65.9391 17.04L66.1391 17.14C65.9791 17.56 65.7124 17.8867 65.3391 18.12C64.9724 18.3533 64.5091 18.47 63.9491 18.47Z"></path>
                <path d="M73.7654 11.77V15.84C73.7654 16.7133 73.5354 17.37 73.0754 17.81C72.6154 18.25 71.9454 18.47 71.0654 18.47C70.1987 18.47 69.5321 18.25 69.0654 17.81C68.6054 17.37 68.3754 16.7133 68.3754 15.84V11.77H69.4454V15.71C69.4454 16.33 69.5787 16.79 69.8454 17.09C70.112 17.39 70.5187 17.54 71.0654 17.54C71.6187 17.54 72.0287 17.39 72.2954 17.09C72.5621 16.79 72.6954 16.33 72.6954 15.71V11.77H73.7654Z"></path>
                <path d="M78.2852 11.77C78.9919 11.77 79.5519 11.9467 79.9652 12.3C80.3852 12.6533 80.5952 13.13 80.5952 13.73C80.5952 14.35 80.3852 14.83 79.9652 15.17C79.5519 15.5033 78.9919 15.67 78.2852 15.67L78.1852 15.73H76.6552V18.37H75.5952V11.77H78.2852ZM78.2052 14.84C78.6386 14.84 78.9586 14.7533 79.1652 14.58C79.3786 14.4 79.4852 14.1267 79.4852 13.76C79.4852 13.4 79.3786 13.13 79.1652 12.95C78.9586 12.77 78.6386 12.68 78.2052 12.68H76.6552V14.84H78.2052ZM78.8352 15.06L80.9852 18.37H79.7552L77.9152 15.48L78.8352 15.06Z"></path>
                <path d="M84.9954 11.67C85.6354 11.67 86.1887 11.8067 86.6554 12.08C87.122 12.3533 87.482 12.7433 87.7354 13.25C87.9887 13.7567 88.1154 14.3633 88.1154 15.07C88.1154 15.7767 87.9887 16.3833 87.7354 16.89C87.482 17.3967 87.122 17.7867 86.6554 18.06C86.1887 18.3333 85.6354 18.47 84.9954 18.47C84.3621 18.47 83.812 18.3333 83.3454 18.06C82.8787 17.7867 82.5187 17.3967 82.2654 16.89C82.0121 16.3833 81.8854 15.7767 81.8854 15.07C81.8854 14.3633 82.0121 13.7567 82.2654 13.25C82.5187 12.7433 82.8787 12.3533 83.3454 12.08C83.812 11.8067 84.3621 11.67 84.9954 11.67ZM84.9954 12.6C84.5821 12.6 84.2254 12.6967 83.9254 12.89C83.6321 13.0833 83.4054 13.3633 83.2454 13.73C83.0854 14.0967 83.0054 14.5433 83.0054 15.07C83.0054 15.59 83.0854 16.0367 83.2454 16.41C83.4054 16.7767 83.6321 17.0567 83.9254 17.25C84.2254 17.4433 84.5821 17.54 84.9954 17.54C85.4154 17.54 85.7721 17.4433 86.0654 17.25C86.3654 17.0567 86.5954 16.7767 86.7554 16.41C86.9154 16.0367 86.9954 15.59 86.9954 15.07C86.9954 14.5433 86.9154 14.0967 86.7554 13.73C86.5954 13.3633 86.3654 13.0833 86.0654 12.89C85.7721 12.6967 85.4154 12.6 84.9954 12.6Z"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Pagamento por PIX"
      size="md"
      id="pagamentoPixModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 text-center">
          <qrcode-vue class="pix-style" :value="value" :size="size" level="H" />
        </div>

        <div class="col-md-12 text-center mt-3">
          <input type="text" class="form-control" :value="value" disabled>
        </div>
        
        <div class="col-md-12 text-center">
          <button class="btn-send-payment" @click="copyToClipboard()">Copiar qr code pix</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Pagamento por boleto"
      size="md"
      id="pagamentoBoletoModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 text-center">
          <img :src="codBoleto" alt="Boleto pedido">
        </div>

        <div class="col-md-12 text-center">
          <input type="text" :value="value" class="form-control" disabled>
        </div>

        <div class="col-md-12 text-center">
          <button class="btn-send-payment" @click="copyToClipboard()">Copiar código de barras</button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Confirmação de pagamento"
      size="md"
      id="pagamentoCartaoModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row" v-if="pagamentoCartao == true">
        <div class="col-md-12 text-center mt-4 mb-4">
          <span class="checkYes"><i class="fas fa-check"></i></span>
        </div>

        <div class="col-md-12 text-center mt-4">
          <h4>Pagamento realizado com sucesso!</h4>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-md-12 text-center mt-4 mb-4">
          <span class="checkNo"><i class="fas fa-times"></i></span>
        </div>

        <div class="col-md-12 text-center mt-4">
          <h4>Pagamento negado, confirme os dados acima e tente novamente!</h4>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Pagamento na retirada ou na loja"
      size="md"
      id="pagamentoShopkeeperModal"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 text-center">
          <h4>
            Pedido realizado com sucesso, agora só aguardar o lojista aprovar!
          </h4>
        </div>

        <div class="col-md-12 text-center mt-4">
          <h4>
            <b-button @click="gotoPage()" variant="success">Proseguir</b-button>
          </h4>
        </div>
      </div>
    </b-modal>

    <div class="container mt-4" v-if="data == null && loading == false">
      <b-alert show variant="danger">Orçamento não encontrado!</b-alert>
    </div>
  </div>
</template>

<script type="text/javascript" src="https://js.iugu.com/v2"></script>
<script>
import * as Card from 'card';
import makeToast from "../mixins/makeToast";
import validateCpfCnpj from '../utils/validateCpfCnpj'
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'PaymentsApp',
  mixins: [makeToast],

  components: {
    QrcodeVue
  },

  data() {
    return {
      orca_cliente: false,
      orca_expired: false,
      pagamentoCartao: false,
      size: 250,
      showPassword: false,
      reShowPassword: false,
      password: '',
      repassword: '',
      sobrenome: '',
      nome: '',
      whatsapp: '',
      value: '',
      codBoleto: '',
      nomeCompleto: '',
      enderecoCompleto: '',
      loading: false,
      orcamentoValido: false,
      dadosPessoais: true,
      dadosEntrega: false,
      dadosPagamento: false,
      pagamentoSelecionado: '',
      frete: false,
      valorTotal: null,
      valorSubtotal: null,
      valorFrete: null,
      data: null,
      tipoFrete: '',
      clientHasEmail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      number: '',
      ccName: '',
      lastname: '',
      month: '',
      year: '',
      cvv: '',
      months: '',
      installments: 1,
      classCard: '',
      valid: false,
      mostrarCard: false,
      printRadio: '<input type="radio" class="mr-2">',
      coupon: '',
      dataDiscount: '',
      valueDiscount: '',
      valueDiscountPaymentForm: 0
    }
  },

  watch: {
    'frete': function() {
      this.somarValores();
    },
    'ccName': function () {
      const name = document.querySelectorAll('.jp-card-name');
      const nameFull = this.ccName +' '+ this.lastname;
      name[0].innerText = nameFull;
    },
    'lastname': function () {
      const name = document.querySelectorAll('.jp-card-name');
      const nameFull = this.ccName +' '+ this.lastname;
      name[0].innerText = nameFull;
    },
    'month': function () {
      if(this.month > 12) {
        this.makeToast('Oopss!', 'Mês invalido!', 'danger');
        this.month = '';
      } else {
        const cardExpiry = document.querySelectorAll('.jp-card-expiry');
        const cardFull = this.month +'/'+ this.year;
        cardExpiry[0].innerText = cardFull;
      }
    },
    'year': function () {
      if((this.year.length == 4) && (this.year < 2023 || this.year > 2040)) {
        this.makeToast('Oopss!', 'Ano invalido!', 'danger');
        this.year = '';
      } else {
        const cardExpiry = document.querySelectorAll('.jp-card-expiry');
        const cardFull = this.month +'/'+ this.year;
        cardExpiry[0].innerText = cardFull;
      }
    },
    'cvv': function () {
      const cvv = document.querySelectorAll('.jp-card-cvc');
      cvv[1].innerText = this.cvv;
    },
    'pagamentoSelecionado': function() {
      this.getDiscountByPayment();
    }
  },

  mounted() {
    if(this.$route.params.id && this.$route.query.token) {
      this.buscarOrcamento();

      let Script = document.createElement('script');
      Script.setAttribute('src', 'https://js.iugu.com/v2');
      document.head.appendChild(Script);      
    }
  },

  methods: {
    selectFrete(tipo, frete){
      this.printRadio = '<input type="radio" class="mr-2">';
      this.tipoFrete = tipo;
      this.frete = frete;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.value);
      this.makeToast('Sucesso!', 'Copiado com sucesso!', 'success');
    },
    montarEndLoja(data) {
      return data.endereco+' Nº'+data.numero+', '+data.bairro+', '+data.nome+' - '+data.uf+', '+data.cep
    },
    valorParcela(i) {
      if(this.valorTotal != null && i != undefined) {
        var qtd = i+1;
        if(qtd == 1) {
          return this.insertDot(this.valorTotal)
        } else {
          var valor = this.valorTotal / qtd;
          if(valor % 1 === 0) {
            return this.insertDot(valor)
          } else {
            var str = valor.toString();
            var newValue = str.split(".");
            return this.insertDot(newValue[0]);
          }
        }
      }
    },
    selectCard() {
      this.mostrarCard = true;
      new Card({
        form: 'div#cc-form',
        container: '.card-wrapper',
        formSelectors: {
          numberInput: 'input#cc-number',
          nameInput: 'input#ccName',
          expiryInput: 'input#cc-month, input#cc-year',
          cvcInput: 'input#cc-cvv',
        },
        width: 370,
        formatting: true,
        messages: {
          validDate: 'valido\ndata',
          monthYear: 'mm/yyyy',
        },
        placeholders: {
          number: '•••• •••• •••• ••••',
          name: 'Nome completo',
          expiry: '••/••',
          cvc: '•••',
        },
      });
    },
    validCVC(type) {
      const front = document.querySelectorAll('.jp-card')
      if (type == 'back') {
        this.classCard = front[0].className;
        front[0].className = 'jp-card jp-card-flipped';
      }
      if (type == 'front') {
        front[0].className = this.classCard;
      }
    },
    somaQtd(item, tipo) {
      if(tipo == '-') {
        if(item.qtd > 1) {
          item.qtd--;
        }
      } else {
        if( item.qtd == item.qtd_max) {
          this.makeToast('Oopss!', 'Esse produto só tem '+item.qtd_max+' un. disponível!', 'danger');
        } else {
          item.qtd++;
        }
      }
      this.somarValores();
      this. getDiscountByPayment();
    },
    somarValores() {
      const produtos = this.data.orcamento.produto_orcamento;

      this.valorSubtotal = null;
      produtos.map((i) => {
        var price = null;
        if(isNaN(i.preco)){
          var p = i.preco.replace(/[^0-9]/g, '');
          price = parseFloat(p);
        } else {
          price = i.preco;
        }

        var valor = price * i.qtd;
        
        this.valorSubtotal = this.valorSubtotal + valor;
      })

      if(this.frete == true) {
        var freteS = null;
        var valorF = this.data.orcamento.frete_orcamento[0].loja_entrega_frete
        if(isNaN(valorF)) {
          freteS = valorF.replace(/[^0-9]/g, '');
        } else {
          freteS = parseFloat(valorF);
        }
        this.valorTotal = (this.valorSubtotal - this.valueDiscountPaymentForm) + parseFloat(freteS);
      } else {
        this.valorTotal = this.valorSubtotal - this.valueDiscountPaymentForm;
      }
      this.calcDiscount();
    },
    formatMoney(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    montarUrl(tipo, img) {
      var link = '';
      if(tipo == 'logo') {
        link = process.env.VUE_APP_IMAGES_ADDRESS_APP+'/'+img;
      } else if(tipo == 'Belenus') {
        link = 'https://storage.googleapis.com/fotos-prd/'+img;
      } else {
        link = process.env.VUE_APP_FOTOS_URL+img;
      }

      return link
    },
    getDiscountByPayment() {
      if(!this.dadosPagamento) return;

      let discount = '';
      if(this.pagamentoSelecionado == 'P') {
        discount = parseFloat(this.data.orcamento.pagamento_orcamento[0].pix_desconto) / 100;
      } else if(this.pagamentoSelecionado == 'B') {
        discount = parseFloat(this.data.orcamento.pagamento_orcamento[0].boleto_desconto) / 100;
      } else if(this.pagamentoSelecionado == 'E') {
        discount = parseFloat(this.data.orcamento.pagamento_orcamento[0].entrega_desconto) / 100;
      }

      this.valueDiscountPaymentForm = this.valorSubtotal * discount;
      this.somarValores();
    },
    buscarOrcamento() {
      const data = {
        id: this.$route.params.id,
        token: this.$route.query.token
      }

      this.$store.dispatch('startLoader');
      this.loading = true;
      this.$store.dispatch('client/getOrcamento', data)
        .then(async (response) => {
          if(response.data.data.error == true) {
            this.data = null;
            this.makeToast('Oopss!', 'Orçamento não encontrado!', 'danger');
          } else {
            this.data = response.data.data.data;
            
            this.orca_cliente = response.data.data.data.orcamento.orca_cliente;

            if(response.data.data.data.orca_expired) {
              this.orca_expired = response.data.data.data.orca_expired;
            }

            if(this.data.cliente.type == 1){ //cliente
              this.nomeCompleto = this.data.cliente.nome +' '+ this.data.cliente.sobrenome;
            } else if(this.data.cliente.type == 2) { // profissional
              this.nomeCompleto = this.data.cliente.nome;
            } else if(this.data.cliente.type == 3) { // empresa
              this.nomeCompleto = this.data.cliente.nome;
            }

            this.nome = this.data.cliente.nome;
            this.sobrenome = this.data.cliente.sobrenome;
            this.clientHasEmail = this.data.cliente.email;

            const endereco = this.data.orcamento.frete_orcamento[0];
            this.enderecoCompleto = endereco.endereco +' Nº'+endereco.numero+', '+endereco.bairro+', '+endereco.complemento+', '+endereco.cidade+' - '+endereco.estado+', '+endereco.cep;

            if(this.data.cliente.whatsapp && this.data.cliente.whatsapp.number) {
              this.whatsapp = this.data.cliente.whatsapp.number;
            }
            this.somarValores();
          }
        })
        .catch(() => {
          this.data = null;
          this.makeToast('Oopss!', 'Orçamento não encontrado!', 'danger');
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        })
    },
    criarCliente() {
      if(this.password.length <= 5) {
        this.makeToast('Oopss!', 'A senha precisa de no mínimo 6 caracteres!', 'danger');
        return
      }

      if(this.password != this.repassword) {
        this.makeToast('Oopss!', 'As senhas precisam ser iguais!', 'danger');
        return
      }

      const data = {
        nome: this.nome,
        sobrenome: this.sobrenome,
        password: this.password,
        email: this.data.cliente.email,
        cpf: this.data.cliente.cpf_cnpj,
        whatsapp: this.whatsapp,
        contrup_lojista_id: this.data.orcamento.id_lojista,
        update_cot: true,
        orcamento_id: this.data.orcamento.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('client/registerClientApp', data)
        .then(async (response) => {
          if(response.data.data.cliente == true && response.data.data.cadastrado == false) {
            this.makeToast('Sucesso!', 'Conta criada com sucesso', 'success');
            this.buscarOrcamento();
          } else {
            this.makeToast(
              'Oopss!',
              response.data.data.message ?
              response.data.data.message :
              'Tente novamente mais tarde!',
              'danger');
          }
        })
        .catch(() => {
          this.makeToast('Oopss!', 'Tente novamente mais tarde!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    validarCpf() {
      if(validateCpfCnpj('cpf', this.data.cliente.cpf_cnpj) == false){
        this.makeToast( 'Erro', 'CPF não é válido!', 'danger');
        return;
      }

      const data = {
        cpf: this.data.cliente.cpf_cnpj.match(/\d/g).join(""),
        lojista_id: this.data.orcamento.id_lojista
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch("client/validCpf", data)
        .then((response) => {
          if(response.data.cpf == 'false') {
            this.makeToast("Opss", "Esse CPF já está cadastrado, informe outro CPF!", "danger");
            this.data.cliente.cpf_cnpj = '';
          }
        })
        .catch((e) => {
          this.makeToast("Opss", "Não foi possível validar o cpf, tente novamente!", "danger");
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    validarEmail() {
      if(this.data.cliente.email == '') {
        return;
      }

      if(this.data.cliente.email && this.clientHasEmail === this.data.cliente.email) {
        return;
      }

      const data = {
        email: this.data.cliente.email,
        lojista_id: this.data.orcamento.id_lojista
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch("client/validEmail", data)
        .then((response) => {
          if(response.data.email == false) {
            this.makeToast("Opss", "Esse E-Mail já está cadastrado, informe outro E-Mail!", "danger");
            this.data.cliente.email = '';
          }
        })
        .catch((e) => {
          this.makeToast("Opss", "Não foi possível validar o E-Mail, tente novamente!", "danger");
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    insertDot(a, isView = false){
      
      if (isView) return this.formatMoney(a/100);
      
      a = a.toString();
      var beforeDot = a.substring(0, a.length-2);
      var afterDot = a.substring(a.length-2, a.length);
      return this.formatMoney(beforeDot + "." + afterDot);
    },
    avancarMethods(type) {
      if(type == 'pessoais') {
        this.dadosPessoais = false;
        this.dadosEntrega = true;
        this.dadosPagamento = false;
      } else if (type == 'frete') {
        this.dadosPessoais = false;
        this.dadosEntrega = false;
        this.dadosPagamento = true;
      } else if(type == 'pagamento') {
        
        if(this.orca_expired == true){
          this.makeToast('Oopss!', 'Orçamento expirado, converse com seu vendedor!', 'danger');
          return;
        }

        if(this.validForm() == true && this.pagamentoCartao == false) {

          var tipoPag = '';
          if(this.pagamentoSelecionado == 'P') {
            tipoPag = 'pix';
          } else if(this.pagamentoSelecionado == 'C') {
            tipoPag = 'credit_card';
          } else if(this.pagamentoSelecionado == 'B') {
            tipoPag = 'all';
          } else if(this.pagamentoSelecionado == 'E') {
            tipoPag = 'shopkeeper';
          }

          var frete = this.data.orcamento.frete_orcamento[0].loja_entrega_frete;
          var extra = '';
          if(tipoPag == 'credit_card') {
            var qtd = this.months;
            if(qtd == 1) {
              extra = this.months+'X de '+ this.insertDot(this.valorTotal)
            } else {
              
              var valor = this.valorTotal / qtd;
              if(valor % 1 === 0) {
                extra = this.months+'X de '+ this.insertDot(valor);
              } else {
                var str = valor.toString();
                var newValue = str.split(".");
                extra = this.months+'X de '+ this.insertDot(newValue[0]);
              }
            }
          }

          var address = {};
          if(this.tipoFrete == 'F') {
            const endereco = this.data.orcamento.frete_orcamento[0];
            address = {
              street: endereco.endereco,
              number: endereco.numero,
              district: endereco.bairro,
              city: endereco.cidade,
              state: endereco.estado,
              zip_code: endereco.cep
            }
          } else {
            address = {
              street: this.data.lojista.endereco,
              number: this.data.lojista.numero,
              district: this.data.lojista.bairro,
              city: this.data.lojista.nome,
              state: this.data.lojista.uf,
              zip_code: this.data.lojista.cep
            }
          }

          var data = {
            data: {
              produtos: this.data.orcamento.produto_orcamento,
              frete: {
                tipoFrete: this.tipoFrete == 'L' ? 'store' : 'delivery',
                enderecoFrete: this.tipoFrete == 'L' ? '' : this.enderecoCompleto,
                valorFrete: frete == '0,00' ? 0 : frete.replace(/[^0-9]/g, '')
                
              },
              pagamento: this.data.orcamento.pagamento_orcamento[0],
              cliente: {
                nomeCompleto: this.nomeCompleto,
                email: this.data.cliente.email,
                cpf: this.data.cliente.cpf_cnpj,
                whatsapp: this.whatsapp,
                endereco: address
              }
            },
            token: this.token,
            extra: extra,
            balconista_id: this.data.orcamento.id_balconista,
            lojista_id: this.data.orcamento.id_lojista,
            user_id: this.data.orcamento.user_id,
            subtotal: this.valorSubtotal,
            total: this.valorTotal,
            pagamentoSelecionado: tipoPag,
            clerk_id: this.data.orcamento.id_balconista,
            coupon: this.coupon,
            orcamento_id: this.data.orcamento.id
          }

          if(tipoPag == 'credit_card') {
            this.criarToken(data);
          } else {
            this.$store.dispatch('startLoader');
            this.$store.dispatch('balconista/realizarPagamento', data)
              .then((response) => {
                if(data.pagamentoSelecionado == 'pix') {
                  if(response.data.data.data.error == false) {
                    this.value = response.data.data.data.qr_code;
                    this.$bvModal.show('pagamentoPixModal');
                  } else {
                    this.makeToast('Oopss!', 'Erro ao finalizar pedido', 'danger');
                  }
                } else if (data.pagamentoSelecionado == 'shopkeeper') {
                  if(response.data.data.data.error == false) {
                    this.$bvModal.show('pagamentoShopkeeperModal');
                  } else {
                    this.makeToast('Oopss!', 'Erro ao finalizar pedido', 'danger');
                  }
                } else {
                  if(response.data.data.data.error == false) {
                    this.value = response.data.data.data.boleto.digitable_line;
                    this.codBoleto = response.data.data.data.boleto.barcode;
                    this.$bvModal.show('pagamentoBoletoModal');
                  } else {
                    this.makeToast('Oopss!', 'Erro ao finalizar pedido', 'danger');
                  }
                }
              })
              .catch(() => {
                this.data = null;
                this.makeToast('Oopss!', 'Erro ao finalizar pedido', 'danger');
              })
              .finally(() => {
                this.$store.dispatch('endLoader');
              })
          }
        }
      }
    },
    criarToken(data) {
      Iugu.setAccountID('D9BC3DAFD6314DE2B01323646B94F29B');
      Iugu.setup();
      Iugu.setTestMode(false);
      const cc = Iugu.CreditCard(
        this.number,
        this.month,
        this.year,
        this.ccName,
        this.lastname,
        this.cvv
      );
      Iugu.createPaymentToken(cc, (response) => {
        if (response.errors) {
          this.makeToast('Oops!', 'Não foi possível salvar o cartão', 'danger');
        } else {
          data.token = response.id;

          this.$store.dispatch('startLoader');
          this.$store.dispatch('balconista/realizarPagamento', data)
            .then((response) => {
              if(response.data.data.data.error == false) {
                this.pagamentoCartao = true;
                this.$bvModal.show('pagamentoCartaoModal');
              } else {
                this.$bvModal.show('pagamentoCartaoModal');
                this.makeToast('Oopss!', 'Pagamento negado, confirme os dados acima e tente novamente!', 'danger');
              }
            })
            .catch(() => {
              this.data = null;
              this.makeToast('Oopss!', 'Erro ao finalizar pedido', 'danger');
            })
            .finally(() => {
              this.$store.dispatch('endLoader');
            })
        }
      });
    },
    validForm() {
      var valid = true;
      if(validateCpfCnpj('cpf', this.data.cliente.cpf_cnpj) == false){
        this.makeToast( 'Erro', 'CPF não é válido!', 'danger');
        valid = false;
      }

      if(this.tipoFrete == ''){
      this.makeToast( 'Erro', 'Informe o meio de entrega!', 'danger');
      valid = false;
      }

      if(this.nomeCompleto == ''){
        this.makeToast( 'Erro', 'Informe o seu nome completo!', 'danger');
        valid = false;
      }

      if(this.data.cliente.email == '' || this.data.cliente.email == null){
        this.makeToast( 'Erro', 'Informe o seu e-mail!', 'danger');
        valid = false;
      }

      if(this.pagamentoSelecionado == 'C') {
        if(this.months == '') {
          this.makeToast('Oops!', 'Selecione a quantidade de parcela(s)!', 'danger');
          valid = false;
        }
        if(this.number == '') {
          this.makeToast('Oops!', 'Preencha o número do seu cartão!', 'danger');
          valid = false;
        }
        if(this.ccName == '') {
          this.makeToast('Oops!', 'Informe seu nome!', 'danger');
          valid = false;
        }
        if(this.lastname == '') {
          this.makeToast('Oops!', 'Informe seu sobrenome!', 'danger');
          valid = false;
        }
        if(this.month == '') {
          this.makeToast('Oops!', 'Informe o mês da validade do seu cartão!', 'danger');
          valid = false;
        }
        if(this.year == '') {
          this.makeToast('Oops!', 'Informe o ano da validade do seu cartão!', 'danger');
          valid = false;
        }
        if(this.cvv == '') {
          this.makeToast('Oops!', 'Informe o cvv do seu cartão!', 'danger');
          valid = false;
        }
      }

      return valid;
    },
    applyCoupom() {
      if(this.coupon.length < 4) {
        this.makeToast('Opss!', 'Minimo de 5 letras' , 'danger');
        return
      }
      
      const data = {
        construpUserId: this.data.orcamento.id_lojista,
        coupon: this.coupon,
        userId: this.data.cliente.user_id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('balconista/verifyCoupon', data)
        .then((response) => {
          if(response.data.data.error) {
            this.makeToast('Opss!', response.data.data.message, 'danger');
          } else {
            this.dataDiscount = response.data.data.data;
            this.calcDiscount();
          }
          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
        })
    },
    calcDiscount() {
      if(!this.dataDiscount) return;

      let discount = 0;
      
      if(this.dataDiscount.type == 'percentage') {
        discount = parseInt(this.valorSubtotal * (this.dataDiscount.value / 100));
      }else {
        discount = this.dataDiscount.value * 100;
      }

      if(this.dataDiscount.min_order && Number(this.dataDiscount.min_order) > this.valorTotal) {
        this.makeToast('Opss!', 'Pedido minio para esse cupom é de R$ '+this.dataDiscount.min_order, 'danger');
        return
      }
      const maxDiscount = Number(this.dataDiscount.max_discount) * 100;

      if(maxDiscount == 0) {
        this.valueDiscount = discount;
      } else {
        this.valueDiscount = discount < maxDiscount ? discount : maxDiscount;
      }

      this.valorTotal = this.valorTotal - this.valueDiscount;
    },
    gotoPage() {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
<style scoped>
.cardSoma {
  background: #f4f6f8;
  padding: 25px;
  border-radius: 3px;
}
.cardProdutoImg {
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}
.selecionaQtd {
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  cursor: pointer;
}
.cardProduto {
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  padding: 15px 0;
}
.imgProduto {
  width: 80px;
}
.cardEndHeader {
  border: 1px solid #dfdfdf;
  border-radius: 3px;
  padding: 10px 5px;
  text-align: left;
  min-height: 160px;
}
.titleEnd {
  background-color: #3a3939;
  color: #FFF;
}
.fontTitle {
  font-size: 1.5rem;
  color: #222;
  cursor: pointer;
}
.cursor-pointer{
  cursor: pointer;
}
.cardItem {
  background-color: #FFF;
  border-radius: 3px;
  padding: 10px 10px;
}
.content {
  background-color: #f4f6f8;
  min-height: 100vh;
  padding: 40px 10px;
}
.header {
  height: 80px;
  background: #FFF;
  box-shadow: 0 0 2px 0 hsla(0,0%,80%,.5);
  color: #898792;
  display: flex;
  align-items: center;
}
.footer {
  height: 80px;
  background: #f4f6f8;
  box-shadow: 0 0 2px 0 hsla(0,0%,80%,.5);
}
.logo {
  max-width: 165px;
  max-height: 70px;
}
.pagamentoSeguro {
  display: flex;
  justify-content: right;
  align-items: center;
}
.btn-avancar {
  background: #3fc583;
  color: #FFF;
  height: 50px;
  width: 200px;
  border: none;
  border-radius: 3px;
  font-size: 18px;
  font-weight: 900;
}
.btn-avancar:hover {
  background: #3fc582bb;
}
.btn-avancar:disabled {
  background: #63f0a9bb;
}
.success {
  background: #3fc583 !important;
}
.totalFinal {
  color: #3fc583;
  font-weight: 900;
  font-size: 22px;
}
.formatCardCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cardQr {
  justify-content: center;
  display: flex;
  align-items: center;
}
.btn-send-payment {
  margin-top: 20px;
  width: 100%;
  padding: 15px 0;
  background: #3fc583;
  color: #FFF;
  font-weight: bold;
  font-size: 18px;
  border: none;
  border-radius: 3px;
}
.checkYes {
  font-size: 100px;
  color: #3fc583;
  border: 10px solid #3fc583;
  border-radius: 50%;
  padding: 0 25px;
}
.checkNo {
  font-size: 100px;
  color: #ed6262;
  border: 10px solid #ed6262;
  border-radius: 50%;
  padding: 0 40px;
}
.eyeInput {
  position: absolute;
  right: 25px;
  top: 39px;
}
/* #alterarGrid {
  flex-direction: row-reverse;
} */
@media screen and (min-width: 768px) {
  .cardItemRow {
    margin-left: 0.5rem !important;
  }
  .blockBtnHide {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .blockBtn {
    display: none;
  }
  .blockBtnShow {
    width: 100%;
  }
  .logo {
    max-width: 135px;
  }
  .fontSelectPro {
    font-size: 14px;
  }
}
</style>
